<template>
  <BgImageLayout title="Metadata fields">
    <ag-grid-wrapper
      ref="fieldsWrapper"
      :options="options"
      :separator="true"
      :include-search-box="true"
      :needs-update-preprocessing="true"
      :actions="fieldsWrapperActions"
      store-namespace="metaDataFields"
      service-namespace="meta-data-fields"
      @requested-update="prepareSubmission($event)"
      @created="resetFormData()"
      @show-form="createNewField()"
    />
    <form-create-meta-data-field
      v-if="editable"
      :showing="!!editable"
      :edit-mode="editMode"
      :editable="editable"
      @close="closeForm()"
      @create="refreshFromServer()"
      @update="refreshFromServer()"
    />
    <lm-dialog v-if="deletable" :uid="uid" :entity="deletable" store-namespace="metaDataFields" />
  </BgImageLayout>
</template>

<script>
import { dateRenderer, dateSorter, entityNameSorter, getProp } from '@/lib/generic.utils'
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'
import LmEntityActions from '@components/ag-grid-helpers/EntityActions'
import { FormCreateMetaDataField } from '@components/forms'
import LmDialog from '@components/lm-blocks/Dialog'
import { cloneDeep } from 'lodash'
import { uid } from 'quasar'
import { mapState } from 'vuex'

export default {
  name: 'MetaDataFieldsIndex',
  components: {
    AgGridWrapper,
    FormCreateMetaDataField,
    LmDialog
  },
  data() {
    return {
      showForm: false,
      deletable: null,
      editable: null,
      editMode: false,
      fieldTemplate: {
        name: null,
        description: null,
        type_id: null,
        value_options: [],
        is_required: false,
        copy_to_next_year: false,
        id: null,
        default_values: [],
        category_id: null,
        entity_id: null
      },
      uid: uid()
    }
  },
  computed: {
    ...mapState({
      fields: state => state.metaDataFields.all
    }),
    options() {
      return {
        rowData: cloneDeep(this.fields),
        context: {
          actions: [
            {
              label: 'Edit',
              onClick: this.edit,
              color: 'tertiary'
            },
            {
              icon: 'trash',
              tooltip: 'Delete',
              onClick: this.delete,
              color: 'faded'
            }
          ]
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            tooltipField: 'name',
            cellRenderer: params => params.value,
            editable: true
          },
          {
            headerName: 'Description',
            field: 'description',
            tooltipField: 'description',
            cellRenderer: params => params.value,
            editable: true
          },
          {
            headerName: 'Value Options',
            field: 'value_options',
            tooltipField: 'value_options'
          },
          {
            headerName: 'Required',
            field: 'is_required',
            cellRenderer: params => (params.value ? 'Yes' : 'No'),
            tooltipValueGetter: params => (params.value ? 'Yes' : 'No')
          },
          {
            headerName: 'Type',
            field: 'type',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'label'),
            tooltipValueGetter: params => getProp(params.value, 'label')
          },
          {
            headerName: 'Category',
            field: 'category',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name'),
            tooltipValueGetter: params => getProp(params.value, 'name')
          },
          {
            headerName: 'Entity',
            field: 'entity',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'label'),
            tooltipValueGetter: params => getProp(params.value, 'label')
          },
          {
            headerName: 'Created',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: 'Updated',
            field: 'updated_at',
            comparator: dateSorter,
            cellRenderer: params => dateRenderer(params.value),
            tooltipValueGetter: params => dateRenderer(params.value)
          },
          {
            headerName: '',
            cellRendererFramework: LmEntityActions
          }
        ]
      }
    },
    fieldsWrapperActions() {
      return [
        {
          label: 'Create new field',
          event: 'show-form',
          type: 'button',
          color: 'tertiary',
          size: 'md'
        }
      ]
    }
  },
  methods: {
    prepareSubmission(event) {
      let payload = cloneDeep(event.item)
      let label = event.field === 'required' ? `${event.field}` : `${event.field}_id`
      payload[label] = event.updated.id
      this.$refs.fieldsWrapper.$emit('update', payload)
    },
    sendData(formData) {
      let data = cloneDeep(formData)
      delete data.errors
      delete data.originalData
    },
    refreshFromServer() {
      this.$store.dispatch('metaDataFields/getAll')
    },
    createNewField() {
      this.$set(this, 'editable', this.fieldTemplate)
    },
    edit(fieldRow) {
      this.editMode = true
      this.$set(this, 'editable', fieldRow.data)
      this.showForm = true
    },
    closeForm() {
      this.showForm = false
      this.editMode = false
      this.$set(this, 'editable', null)
    },
    delete(params) {
      this.$set(this, 'deletable', params.data)
      this.$store.dispatch('metaDataFields/deleteConfirmation', {
        id: this.deletable.id,
        dialogUid: this.uid
      })
    }
  }
}
</script>
